<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader" />
      <rule-game :title="ruleTitle.rule" :value="ruleGame" />
      <rule-game :title="ruleTitle.freespin" :value="ruleFreespin" />
      <rule-game :title="ruleTitle.score" :value="ruleScore" />
      <rule-game :title="ruleTitle.paytable" :value="rulePaytable" />
    </div>
  </div>
</template>

<script>
import Fsbanner from '../../assets/gamerule/fruitslot/Fs_Banner.png';
import Fsrule from '../../assets/gamerule/fruitslot/fruit_text1.png';
import Fsspin from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Base_Center.png';
import Fsmp from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Base_02.png';
import Fstrade from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Base_03.png';
import Fsguess from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Base_01.png';
import Fssb from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Base_04.png';
import Fsorage from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Orage_02.png';
import Fsapple from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Apple_01.png';
import Fsmelon from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Melon_01.png';
import Fsbell from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Bell_01.png';
import Fslucky from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Lucky_01.png';
import Fsstar from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Star_01.png';
import Fs77 from '../../assets/gamerule/fruitslot/Fs_Ui_Info_77_01.png';
import Fsbar from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Bar_01.png';
import Fslogo from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Logo_01.png';
import Fsorage3 from '../../assets/gamerule/fruitslot/Fs_Ui_Info_Orage_01.png';
import Fs16 from '../../assets/gamerule/fruitslot/1-6.png';
import Fs813 from '../../assets/gamerule/fruitslot/8-13.png';

export default {
  name: 'rule_friutslot',
  data() {
    return {
      ruleHeader: {
        gameName: 'ฟรุตลูเลตสลอต (Fruit Roulette Slots)',
        boardImg: Fsbanner,
      },
      ruleTitle: {
        freespin: 'Free Spins Feature',
        score: 'Main Game',
        paytable: 'Symtable Payout Values',
      },
      ruleGame: [
        {
          image: Fsrule,
          type: 'imageNoborderSlot',
          class: 'w-30',
        },
        {
          type: 'textSlot',
          text:
            '- เมื่อเข้าจะเห็นช่อง Bet คือ เงินที่ใช้เดิมพัน',
          class: 'ml-3',
        },
        {
          type: 'textSlot',
          text:
            '- ผู้เล่นสามารถกด - / + เพื่อเพิ่มเงิน Bet',
          class: 'ml-3',
        },
        {
          type: 'textSlot',
          text:
            '- จากนั้นเลือก Symbol ที่ต้องการเดิมพัน แล้วกดปุ่ม Spin ',
          class: 'ml-3',
        },
        {
          type: 'textSlot',
          text:
            '- หากชนะจะเข้าโหมด Big Or Small ผู้เล่นสามารถเลือกเดิมพันระหว่าง 1-6 (Small) และ 8-13 (Big) ระบบจะทำการสุ่มตัวเลขจาก 1-13 หากตัวเลขออกในช่วงที่ผู้เล่นเดิมพัน ผู้เล่นจะได้เงินเดิมพันเพิ่มขึ้นสองเท่าจากเงินที่ผู้เล่นเดิมพัน และสามารถเล่นต่อได้เรื่อยๆ หากแพ้ผู้เล่นจะเสียเงินทั้งหมด',
          class: 'ml-3',
        },
      ],
      ruleFreespin: [
        {
          type: 'textSlot',
          text:
            '- FreeSpins จะเกิดแบบสุ่ม หาก Free Spin ทำงานจะทำการหมุนกงล้อไฟเพิ่มอีกครั้ง',
          class: 'ml-3',
        },
      ],
      ruleScore: [
        {
          type: 'fiveImageTextNew',
          image: Fsspin,
          class: 'w-50',
          text: '- ปุ่มนี้เรียกว่า',
          textCol: ' Spin ',
          textCon: 'ใช้สำหรับเริ่มเกมส์หรือเริ่มเดิมพัน',
          image2: Fsmp,
          class2: 'w-60',
          text2: '- ปุ่มนี้เรียกว่า',
          textCol2: ' Minus/Plus ',
          textCon2: 'แทนเป็นการหยอดเหรียญเข้าตู้ ใช้สำหรับเพิ่มลดจำนวนเงิน BET ได้แก่ 1 5 10',
          image3: Fstrade,
          class3: 'w-60',
          text3: '- ปุ่มนี้เรียกว่า',
          textCol3: ' Trade ',
          textCon3: 'ใช้สำหรับโยกย้ายเงินระหว่าง',
          textCol3_2: ' Bonus-win ',
          textCon3_2: 'กับ',
          textCol3_3: ' Credit ',
          image4: Fsguess,
          class4: 'w-60',
          text4: '- ปุ่มนี้เรียกว่า',
          textCol4: ' Guess ',
          textCon4: 'ใช้เลือกเดิมพัน',
          textCol4_2: ' 1-6(Small) ',
          textCon4_2: 'และ',
          textCol4_3: ' 8-13(Big) ',
          image5: Fssb,
          class5: 'w-60',
          text5: '- ปุ่มนี้ไว้สำหรับเลือกเดิมพันตาม',
          textCol5: ' Symbol ',
          textCon5: 'ที่ผู้เล่นต้องการเดิมพัน จะทำงานตาม',
          textCol5_2: ' Bet ',
          textCon5_2: 'ที่เลือกไว้',
        },
      ],
      rulePaytable: [
        {
          type: 'rowImageText',
          image: Fsapple,
          class: 'w-60',
          text: 'X 5',
          image2: Fsorage,
          class2: 'w-60',
          text2: 'X 10',
          image3: Fsmelon,
          class3: 'w-60',
          text3: 'X 15',
          image4: Fsbell,
          class4: 'w-60',
          text4: 'X 20',
          image5: Fslucky,
          class5: 'w-60',
          text5: 'X 20',
          image6: Fsstar,
          class6: 'w-60',
          text6: 'X 30',
          image7: Fs77,
          class7: 'w-60',
          text7: 'X 40',
          image8: Fsbar,
          class8: 'w-60',
          text8: 'X 100',
          image9: Fslogo,
          class9: 'w-60',
          text9: 'โอกาสได้ Free spin',
          text91: ' หรือ ไม่ได้เลย',
          image10: Fsorage3,
          class10: 'w-60',
          text10: 'X 3',
          image11: Fs16,
          class11: 'w-70',
          text11: 'แทงต่ำ',
          text111: '(Small)',
          image12: Fs813,
          class12: 'w-70',
          text12: 'แทงสูง',
          text121: '(Big)',
        },

      ],
    };
  },
};
</script>
